module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-component" data-state="pending">\n    <div id="subregion-file-select" class="import-upload-part"></div>\n<!--\n    <p class="hint">\n        Nur Bildateien.\n    </p> -->\n</div>';
}
return __p;
};